import actionCreatorFactory from 'typescript-fsa';
import { Dispatch, Action } from 'redux';
import { postAPI } from '../util/APIUtils';

import { appActions } from './appAction';
import { UploadFile } from '../states/viewerState';

export interface InitViewer {
    type: 'revision' | 'editing' | 'examination';
    actId: string;
    revision: string;
    editingId: string;
    stepId: string;
    miekesi: boolean;
    highlight: string;
    nodeId: string;
    contents: string;
    metadata: object;
    caption: object;
    countHasChild: number,
    actState: string,
    mode: 'current' | 'history',
    title: string,
    maxStepId: number,
    posNextPrev: number,
};

export interface FileUploadAPIParam {
    type: 'revision' | 'editing' | 'examination';
    actId: string;
    revision: string;
    editingId: string;
    stepId: string;
    miekesi: boolean;
    highlight: string;
    nodeId: string;
    accountId: string;
    idid: string;
    uploadNodeId: string;
    uploadFile: UploadFile[];
    mode: 'current' | 'history'
};

const actionCreator = actionCreatorFactory();

export const viewerActions = {
    initViewer: actionCreator<InitViewer>('ACTION_INIT_VIEWER'),
    setPosNextPrev: actionCreator<number>('ACTION_SET_POSNEXTPREV'),
    comitUploadFileAsync: (param: FileUploadAPIParam) => {
        return async (dispatch: Dispatch<Action>) => {
            try {
                // アップロードlambda呼び出し
                const url = `/acts/${param.actId}/${param.revision}/fileupload`;
                const options = {
                    accountid: param.accountId,
                    idid: param.idid,
                    nodeId: param.uploadNodeId,
                    uploadFile: JSON.parse(JSON.stringify(param.uploadFile)),
                };
                await postAPI(url, options);

                // 個別表示画面再描画
                if (param.type === 'revision') {
                    await appActions.initRevisionViewerAsync(
                        param.actId,
                        param.revision,
                        param.miekesi,
                        param.highlight,
                        param.nodeId,
                        param.mode
                    )(dispatch);
                } else {
                    await appActions.initEditingViewerAsync(
                        param.actId,
                        param.editingId,
                        param.stepId,
                        param.miekesi,
                    )(dispatch);
                }
            } catch (err) {
                console.log(err);
            }
        }
    }
};
